// extracted by mini-css-extract-plugin
module.exports = {"linkContainer":"Header_linkContainer__1IIuE","lastLinkContainer":"Header_lastLinkContainer__1b2i9","link":"Header_link__2wI74"};